import { GeneralLocaleTypes } from '../locales.types'

const generalLocaleNo: GeneralLocaleTypes = {
  minute: 'minutt',
  minutes: 'minutt',
  min: 'min',
  showingOf: 'Viser {{ visibleRows }} av {{ totalDataRows }}',
  showLess: 'Vis mindre',
  showMore: 'Vis meir',
  fileSelect: 'Velg en fil',
  userNotFound: 'Bruker ikke funnet',
  noMoreResults: 'Ingen flere resultater',
  teacher: 'Lærer',
  feideFetchStatus: {
    title: 'Feide-synkronisering...',
    fetching: 'Oppdaterer database med Feide-informasjon',
    error: 'Det oppstod en feil under forsøk på å hente informasjon fra feide',
    success: 'Studentoppdatering fra Feide var vellykket'
  },
  filters: {
    text: {
      filterBy: 'Filtrer etter:',
      filterResults: 'Filtreringsresultat',
      clearFilters: 'Fjern filtre',
      selectItem: 'Vell eit {{ topic }}'
    },
    status: {
      title: 'Status',
      item: {
        allAssignments: 'Alle oppgåver',
        progress: 'Aktiv',
        upcoming: 'Planlagd',
        finished: 'Inaktiv'
      }
    },
    topics: {
      title: 'Tema'
    },
    assigned: {
      title: 'Tildelt',
      item: {
        students: 'elevar',
        groups: 'grupper'
      }
    },
    planets: {
      title: 'Planetar'
    },
    skills: {
      title: 'Ferdigheiter'
    }
  },
  imageAlt: {
    login: {
      gameCharacters: 'Spelkarakterar'
    }
  },
  status: {
    error: {
      somethingWentWrong: 'Noko gjekk gale',
      required: 'Denne oppføringen er obligatorisk',
      shouldBeAnEmail: 'Skal be om en e-post',
      emailDoesntMatch: 'E-post stemmer ikke',
      passwordDoesntMatch: 'Passordet stemmer ikke',
      notFound: {
        title: 'Oops! <br/> Vi finner ikke siden du leter etter.',
        description:
          'Dette kan skyldes at siden ikke finnes lenger, eller at innholdet har blitt flyttet. <customLink>Gå til forsiden</customLink> eller velg en annen side fra hovedmenyen.'
      },
      cannotUndoThisAction:
        'Du kan <strong>ikke</strong> angre denne handlingen.'
    }
  },
  state: {
    nrOfModesSelected_0: 'Ingen moduser valgt',
    nrOfModesSelected: '{{ count }} Modus valgt',
    nrOfModesSelected_plural: '{{ count }} moduser valgt',
    selected: 'Valt',
    notSelected: 'Ikke valgt',
    selectedNumber: '{{ selectedNumber }} valt',
    removed: 'Fjerna',
    deleted: 'Sletta',
    modified: 'Modifisert',
    started: 'Påbyrja',
    ended: 'Avslutta',
    comingSoon: 'Kommer snart',
    quitEditing: 'Forlat siden?',
    searchResultsFor: 'Søkeresultater for {{ value }}',
    loading: 'Laster...',
    studentAdded: 'Elev lagt til',
    ok: 'Ok'
  },
  selectAll: 'Vel alle',
  actions: {
    addAndClose: 'Legg til og lukk',
    addAndContinue: 'Legg til og fortsett',
    addNewTopic: 'Legg til et oppdrag',
    edit: 'Rediger',
    delete: 'Slett',
    remove: 'Fjern',
    send: 'Sende',
    next: 'Neste',
    back: 'Attende',
    save: 'Lagre {{ addOn }}',
    update: 'Oppdater {{ addOn }}',
    select: 'Vel',
    confirm: 'Bekreft',
    cancel: 'Avbryt',
    report: 'Sjå rapport ',
    editParentsName: 'Rediger namn på føresette',
    moveToGroup: 'Flytt til ei gruppe',
    revoke: 'Fjern',
    moreOptions: 'Fleire val',
    saveCustomer: 'Redd kunde',
    close: 'Lukk',
    return: 'Gå tilbake',
    submit: 'Send inn',
    add: 'Legg til',
    view: 'Opne',
    createGroup: 'Lag en gruppe',
    saveGroup: 'Lagre gruppe',
    saveChanges: 'Lagre endringar',
    goToArticle: 'Gå til artikkelen',
    keepEditing: 'Rediger videre',
    quit: 'Ja, forlat',
    show: 'Vis',
    hide: 'Skjul',
    unHide: 'Gjenopprett',
    previous: 'Tidligere'
  },
  user: {
    accountSettings: 'Kontoinnstillingar'
  },
  errors: {
    assignmentTitleIsRequired: 'Vennligst skriv inn et oppgavenavn',
    invalidDate: 'Ugyldig dato',
    invalidTime: 'Ugyldig tid',
    shouldNotBeEmpty: 'Skal ikke være tom',
    shouldNotBeEmptyAddon: '{{ key }} skal ikke være tom',
    unexpectedError: 'Uventet feil',
    notSaved: 'Dine endringer vil <strong>ikke</strong> bli lagret.'
  },
  loadMoreResults: 'Last inn flere resultater',
  entry_one: {
    one: 'Entry',
    other: 'Entries'
  },
  validation: {
    required: 'Dette er et obligatorisk felt'
  }
}

export default generalLocaleNo
